<script lang="ts">
	import FormContainer from '$lib/components/form/FormContainer.svelte'
	import FormHeader from '$lib/components/form/FormHeader.svelte'
	import FormMore from '$lib/components/form/FormMore.svelte'
	import type { RegistrationForm } from '$lib/domain/signUp/registrationForm'
	import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
	import { _ } from '@repo/i18n'
	import { InputType } from '@repo/ui'
	import { countriesList, isEuCountry } from '@repo/ui'
	import { Checkbox } from '@repo/ui'
	import { Input } from '@repo/ui'
	import { Select } from '@repo/ui'
	import { user } from '@repo/ui'
	import { getContextErrors } from '@store/errors'

	interface Props {
		form: RegistrationForm
	}

	let { form = $bindable() }: Props = $props()

	const errors = getContextErrors()

	function prefillForm() {
		if (!form.affiliate.billingDetail.invoicingEmail) {
			copyEmail()
		}
	}

	prefillForm()

	function copyEmail() {
		form.affiliate.billingDetail.invoicingEmail = $user.email
		errors.upsert('emailInvoicing', null)
	}

	function handleCopyChange(checked: boolean) {
		if (checked) {
			copyEmail()
		}
	}

	let sameInvoicingEmail = $state(form.affiliate.billingDetail.invoicingEmail === $user.email)

	let displayVat = $derived(isEuCountry(form.affiliate.billingDetail.countryCode))
	let requireVat = $tenantSettings.affiliatesVatRequired
</script>

<FormHeader
	description={$_('signUpAffiliate.billing.description')}
	headline={$_('signUpAffiliate.billing.headline')}
/>

<FormContainer>
	<Input
		name="nameInvoicing"
		label={$_('form.legalName')}
		max={255}
		required
		bind:value={form.affiliate.billingDetail.name}
	/>

	<Input
		name="emailInvoicing"
		disabled={sameInvoicingEmail}
		label={$_('form.emailInvoicing')}
		required
		type={InputType.email}
		bind:value={form.affiliate.billingDetail.invoicingEmail}
	>
		<div class="mt-1"></div>
		<Checkbox
			label={$_('form.emailSame')}
			onChange={handleCopyChange}
			small
			smallText
			bind:checked={sameInvoicingEmail}
		/>
	</Input>

	<Input
		name="address1"
		label={$_('form.address.address')}
		max={255}
		required
		bind:value={form.affiliate.billingDetail.addressLine1}
	/>

	<div class="-mt-4"></div>

	<FormMore label={$_('form.address.additionalAddress')}>
		<Input
			name="address2"
			label={$_('form.address.address2')}
			max={255}
			bind:value={form.affiliate.billingDetail.addressLine2}
		/>
	</FormMore>

	<Input
		name="city"
		label={$_('form.address.city')}
		max={255}
		required
		bind:value={form.affiliate.billingDetail.city}
	/>

	<Input
		name="zip"
		label={$_('form.address.zip')}
		max={50}
		required
		bind:value={form.affiliate.billingDetail.postalCode}
	/>

	<Select
		name="country"
		label={$_('form.address.country')}
		options={countriesList()}
		required
		bind:value={form.affiliate.billingDetail.countryCode}
	/>

	{#if displayVat}
		<Input
			name="vat"
			label={$_('form.vat')}
			max={50}
			required={requireVat}
			bind:value={form.affiliate.billingDetail.vat}
		/>
	{/if}
</FormContainer>

<div class="mb-10"></div>
